module.exports = __webpack_public_path__ + "media/Video 73.d5d3443a.mp4";